/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Image, Space } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { TextField } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { ListTable } from './ListTable';
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import DeleteModal from "../../../../Shared/components/DeleteModal";


const TaxSetup = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const { history } = props;
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [deleteModal, setDeleteModal] = useState(false);
    const [form, setForm] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Tax Setup', history, 'Younote Admin')) {
                dispatchFilter(sortBy, sortOrder);
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const onDelete = (data) => {
        setForm(data);
        setDeleteModal(true);
    }

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'country-taxes',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }
    const classes = customStyles();

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Tax Setup', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Tax Setup'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Tax Setup', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={classes.textAlignRight}>
                                    <Space size={[20, 20]} direction="horizontal" align="center" >                                        {
                                        roleManagement !== '' && checkCRUDPermission('Tax Setup', 'create', 'Younote Admin') &&
                                        <NavLink
                                            to={"/younote-admin/setup/tax-setup/create"}
                                            className={clsx(classes.customLink)}>
                                            <Image
                                                src={AddIcon}
                                                preview={false}
                                                className={clsx(classes.antImage)}
                                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                        </NavLink>
                                    }
                                    </Space>
                                </Col>
                            </Row>
                            <ListTable
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={form?.id}
                loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={form?.name} url={'country-taxes'}
                title={'Tax Types'} visible={deleteModal} />
        </React.Fragment>
    )
}


export default TaxSetup
